module.exports = __webpack_public_path__ + "static/we-live-in-water-24ead1a592267056ca06665acc437fa0.jpg";